import { Routes } from '@angular/router';
import { GenericErrorComponent } from './generic-error/generic-error.component';


export const routes: Routes = [
  {
    path: 'error',
    component: GenericErrorComponent
  }
];



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/shared.routes.ts